import * as types from "./types";

const mutations = {
  [types.PROCESSING_MANAGER_REPORT](state, value) {
    state.processing = value;
  },
};

export default mutations;
